<div class="op-ckeditor--wrapper">
  <op-ckeditor [context]="context"
    [content]="initialContent"
    (initializeDone)="setup($event)"
    (contentChanged)="updateContent($event)"
    (saveRequested)="saveForm()"
    (editorEscape)="editorEscape.emit()"
    (editorKeyup)="editorKeyup.emit()"
    (editorBlur)="editorBlurred()"
    (editorFocus)="editorFocused()"
   />
</div>

@if (showAttachments && halResource?.attachments) {
  <fieldset
    class="form--fieldset op-ckeditor--attachments"
    >
    <legend class="form--fieldset-legend">
      {{ text.attachments }}
    </legend>
    <op-attachments [resource]="halResource"
      [destroyImmediately]="false"
     />
  </fieldset>
}
